import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { Badge, Button, Modal } from 'react-bootstrap';
import { Loader } from '../../../../../../components/Loader';
import { LinkText } from '../../../../../../libs/ui-kit/common/LinkText/LinkText';
import { useStore } from 'src/modules/users/hooks/useStore';
import { MetroStations } from 'src/modules/users/components/MetroStations/MetroStations';
import { UserAddressesStoreContext } from '../../UserAddresses.widget';

export const UserAddressViewModal: FC = observer(() => {
  const store = useStore(UserAddressesStoreContext);

  return (
    <Modal className="modal-slide" show={store.viewAddressModal.isVisible} onHide={store.viewAddressModal.hide}>
      <Modal.Header>
        <Modal.Title as="h5">Адрес</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mt-4">
          {store.isModalLoading ? (
            <Loader />
          ) : (
            <div>
              <div className="mb-3">
                <div className="font-regular-sm text-muted">Адрес</div>
                <LinkText
                  link={store.chosenViewAddress?.addressLink?.addressLink}
                  text={store.chosenViewAddress?.addressLink?.addressString || ''}
                />
              </div>
              <div className="mb-3">
                <MetroStations stations={store.chosenViewAddress?.metro ?? []} />
              </div>
              <div className="mb-3">
                <div className="font-regular-sm text-muted">Домофон</div>
                <div className="font-regular-base">{store.chosenViewAddress?.intercom}</div>
              </div>
              <div className="mb-3">
                <div className="font-regular-sm text-muted">Идентификатор</div>
                <div className="font-regular-sm text-muted">UUID&nbsp;–&nbsp;{store.chosenViewAddress?.id}</div>
              </div>
              <div className="mb-3">
                <div className="font-regular-sm text-muted">Удален</div>
                <Badge variant={store.chosenViewAddress?.isDeleted ? 'danger' : 'default'}>
                  {store.chosenViewAddress?.isDeletedStatus}
                </Badge>
              </div>
              <div className="mb-3">
                <div className="font-regular-sm text-muted">Комментарий</div>
                <div className="font-regular-base">{store.chosenViewAddress?.comment}</div>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={store.viewAddressModal.hide}>
          Закрыть
        </Button>
      </Modal.Footer>
    </Modal>
  );
});
